import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../../../../components/global/Button';
import useSpreadsheetUpload from '../../../../../../hooks/useSpreadsheetUpload';
import Alert from '../../../../../../../../components/global/Alert';
import useVirtualPageView from '../../../../../../services/analytics/useVirtualPageView';

const propTypes = {
  onDataReceived: PropTypes.func.isRequired,
  onError: PropTypes.func,
  onCancel: PropTypes.func,
  supportedFileExtensions: PropTypes.arrayOf(PropTypes.string),
};

const UploadPlaceholder = ({
  onDataReceived,
  onError,
  onCancel,
  supportedFileExtensions = ['.xlsx', '.xls', '.csv'],
}) => {
  const { data, error, loading, onSpreadsheetUpload } = useSpreadsheetUpload();

  useVirtualPageView({
    title: 'Import Contacts - Upload Spreadsheet',
    path: '/contacts-import/upload',
  });

  useEffect(() => {
    if (error) {
      onError?.(error);
      return;
    }

    if (data) {
      onDataReceived(data);
    }
  }, [data, error]);

  return (
    <Fragment>
      {error && (
        <Alert type="danger">
          <h4 className="alert-heading mb-1">
            There was an error with your upload
          </h4>
          <p>{error}</p>
        </Alert>
      )}

      <div className="uploader-wrap">
        <label htmlFor="uploader" className="uploader uploader-full">
          <p className="mb-1 text-dark text-extra-bold">
            Upload your spreadsheet or CSV
          </p>
          <p className="mb-0 text-sm">
            You can drag &amp; drop your file here.
          </p>
          <p className="mb-4 text-xs">
            Supported files: {supportedFileExtensions.join(', ')}
          </p>

          <Button className="uploader-button" disabled={loading}>
            {loading ? 'Processing...' : 'Browse Files'}
          </Button>

          <input
            data-testid="spreadsheet-upload"
            id="uploader"
            type="file"
            accept=".xlsx, .xls, .csv"
            onChange={event => {
              const [file] = event.target.files;
              onSpreadsheetUpload(file);
            }}
          />
        </label>
      </div>

      {onCancel && (
        <div className="text-center mt-3">
          <Button onClick={onCancel} btnStyle="link">
            Cancel Import
          </Button>
        </div>
      )}
    </Fragment>
  );
};

UploadPlaceholder.propTypes = propTypes;

export default UploadPlaceholder;
